import { render, staticRenderFns } from "./m-record.vue?vue&type=template&id=b41daf2c&scoped=true&"
import script from "./m-record.vue?vue&type=script&lang=js&"
export * from "./m-record.vue?vue&type=script&lang=js&"
import style0 from "./m-record.vue?vue&type=style&index=0&id=b41daf2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41daf2c",
  null
  
)

export default component.exports